<ion-button fill="outline" size="large" color="dark" expand="block" (click)="toggle()" #header>
  <ion-icon [name]="iconName" slot="start"></ion-icon>
  {{title}}
  <span class="help-icon" *ngIf="help" slot="end">
    <ion-icon slot="end" name="help-circle-outline" (click)="showHelp($event)"></ion-icon>
  </span>
</ion-button>
<div class="acc-body" #body>
  <div #container class="acc-container">
    <ng-content></ng-content>
  </div>
</div>
